import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-240ca796"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLBidHeader" }
const _hoisted_2 = { class: "FTLBidHeader__container" }
const _hoisted_3 = { class: "container__general" }
const _hoisted_4 = { class: "general__title" }
const _hoisted_5 = { class: "general__cheaps" }
const _hoisted_6 = { class: "container__actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, "FTL заявка (ID: " + _toDisplayString(_ctx.$route.params.id) + ")", 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_cheap, {
            class: _normalizeClass(["small font-bold", _ctx.ftlBidStatusCheapClass])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.statusName), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_button_dropdown, { title: "Выберите действие" }, {
          default: _withCtx(() => [
            (_ctx.isLogistBid && _ctx.isD24)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 0,
                  class: "primary small",
                  disabled: _ctx.isDocumentLoading,
                  loading: _ctx.isDocumentLoading,
                  onClick: _ctx.emitD24
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Отправить на подпись в договор Д24 ")
                  ]),
                  _: 1
                }, 8, ["disabled", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.ftlType === 1 && _ctx.isLogistBid)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 1,
                  class: "text small",
                  loading: _ctx.state.is_loading,
                  onClick: _ctx.printLogistBid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Скачать шаблон международной заявки логиста ")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isLogistBid && _ctx.statusId === 14)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 2,
                  class: "primary small",
                  disabled: _ctx.isDownloadLoading,
                  loading: _ctx.isDownloadLoading,
                  onClick: _ctx.emitDownload
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Скачать заявку логиста ")
                  ]),
                  _: 1
                }, 8, ["disabled", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isCanAcceptInWork)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 3,
                  class: _normalizeClass(["primary small", { text: _ctx.isStatusChanging }]),
                  disabled: _ctx.isStatusChanging,
                  loading: _ctx.isStatusChanging,
                  onClick: _ctx.onAcceptInWork
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Принять в работу ")
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isCanEnterCostToBePaid)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 4,
                  class: _normalizeClass(["primary small", { text: _ctx.isEnterCostToBePaidLoading }]),
                  disabled: _ctx.isEnterCostToBePaidLoading,
                  loading: _ctx.isEnterCostToBePaidLoading,
                  onClick: _ctx.onEnterCostToBePaid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Внести сумму к оплате ")
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isCanRepeatCalculateCost)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 5,
                  class: _normalizeClass(["primary small", { text: _ctx.isStatusChanging }]),
                  disabled: _ctx.isStatusChanging,
                  loading: _ctx.isStatusChanging,
                  onClick: _ctx.onRepeatCalculateCost
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Повторно рассчитать стоимость ")
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isCanEnterCarrierData)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 6,
                  class: _normalizeClass(["primary small", { text: _ctx.isEnterCarrierDataLoading }]),
                  disabled: _ctx.isEnterCarrierDataLoading,
                  loading: _ctx.isEnterCarrierDataLoading,
                  onClick: _ctx.onEnterCarrierData
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.enterCarrierDataText), 1)
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isCanCreateOrder)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 7,
                  to: `/ftl/bids/${_ctx.bidId}/create`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_button, { class: "primary small" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Создать заказ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (Boolean(_ctx.orderId))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 8,
                  to: _ctx.getOrderLink
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_button, { class: "small primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Открыть FTL заказ ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.isCanEnterCostPrice)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 9,
                  class: _normalizeClass(["primary small", { text: _ctx.isEnterCostPriceLoading }]),
                  disabled: _ctx.isEnterCostPriceLoading,
                  loading: _ctx.isEnterCostPriceLoading,
                  onClick: _ctx.onEnterCostPrice
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Внести себестоимость ")
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isCanEnterComment)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 10,
                  class: _normalizeClass(["primary small", { text: _ctx.isEnterCommentLoading }]),
                  disabled: _ctx.isEnterCommentLoading,
                  loading: _ctx.isEnterCommentLoading,
                  onClick: _ctx.onEnterComment
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Данных недостаточно ")
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isCanUpdateFtlBid)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 11,
                  to: `/ftl/bids/${_ctx.bidId}/edit`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_button, { class: "primary small" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Редактировать FTL заявку ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.isCanCancelFtlBid)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 12,
                  class: _normalizeClass(["primary small", { text: _ctx.isStatusChanging }]),
                  disabled: _ctx.isStatusChanging,
                  loading: _ctx.isStatusChanging,
                  onClick: _ctx.onCancelBid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Отменить заявку ")
                  ]),
                  _: 1
                }, 8, ["class", "disabled", "loading", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_the_button, {
              class: _normalizeClass(["primary small", { text: _ctx.isInvoicesPrinting }]),
              loading: _ctx.isInvoicesPrinting,
              disabled: _ctx.isInvoicesPrinting,
              onClick: _ctx.onPrintInvoices
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Печать накладных ")
              ]),
              _: 1
            }, 8, ["class", "loading", "disabled", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_the_button, {
          class: "second text small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" Назад ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}